import { Box, BoxProps } from '@mui/material';

import { useSpinnerStyles } from './useSpinnerStyles';

/**
 * https://css-loaders.com/spinner/
 */
export function Spinner({ sx }: Pick<BoxProps, 'sx'>): JSX.Element {
  const { classes } = useSpinnerStyles();

  return (
    <Box
      className={classes.root}
      component="i"
      sx={{
        fontSize: 40,
        ...sx,
      }}
    />
  );
}
